import React from 'react';

const FAQS = [
  {
    q: 'What does Rapid Rune do?',
    a: 'Rapid Rune builds business process automation and provides IT consulting for small and mid-size companies. We design automated workflows, secure email with DMARC and DKIM, configure Microsoft 365 and Google Workspace, and set up marketing automation. You keep one point of contact while we scope, build, and support your project.',
  },
  {
    q: 'How much do your services cost?',
    a: 'We quote a fixed price after a scoping call, so you know the cost before work begins. Smaller projects run as one-time engagements, and ongoing monitoring and support run as a monthly retainer.',
  },
  {
    q: 'How fast can we start?',
    a: 'We respond to inquiries within one business day and can usually begin scoping the same week. Most projects go live within three to six weeks of kickoff.',
  },
  {
    q: 'Do you only work with certain industries?',
    a: 'No. The workflows we automate, such as onboarding, reporting, and data entry, look similar across industries. If your team runs on Microsoft 365 or Google Workspace, we can work with you.',
  },
  {
    q: 'Where is Rapid Rune located?',
    a: 'Rapid Rune is a US-based LLC that works remotely with clients nationwide. Calls, builds, and support all happen over video and screen share, so your location never slows a project down.',
  },
  {
    q: 'What if we already have an IT person or MSP?',
    a: 'We work alongside them. Internal IT keeps running day-to-day operations while we deliver the scoped project, then we hand off documentation so your team owns the result.',
  },
];

// A full-bleed band per question; every answer stays visible.
const FAQ = ({ faqs = FAQS, heading = 'Common questions', testId = 'faq-section' }) => {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };

  return (
    <section id="faq" className="section" data-testid={testId}>
      <div className="wrap faq-grid">
        <header className="faq-head">
          <h2 className="reveal">{heading}</h2>
          <p className="reveal reveal-1">
            {'Something else? Email '}
            <a href="mailto:inquire@rapidrune.com">inquire@rapidrune.com</a>
            {'.'}
          </p>
        </header>
        <dl className="faq-list">
          {faqs.map((f) => (
            <div key={f.q} className="faq-item reveal">
              <dt>{f.q}</dt>
              <dd>{f.a}</dd>
            </div>
          ))}
        </dl>
      </div>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    </section>
  );
};

export default FAQ;
